/** The look (colour, radius, transition) lives with the class in globals.css. */
export const DROP_CURSOR_CLASS = 'rte-drop-cursor';

export const DROP_CURSOR_VISIBLE_CLASS = 'is-visible';

/** On `document.body` for the length of a drag; `globals.css` uses it to disarm every iframe. */
export const RTE_DRAGGING_CLASS = 'rte-dragging';

export const DROP_CURSOR_THICKNESS_PX = 2;

/** Safety net for a drag that leaves the window and never fires `dragend` or `drop` here. */
export const DROP_CURSOR_IDLE_TIMEOUT_MS = 3000;

/** Keeps a clamped pointer just inside the editor, where `posAtCoords` still resolves. */
export const DROP_CURSOR_EDGE_INSET_PX = 8;

/** How close to a scroll container's edge the pointer must get before the page starts moving. */
export const AUTO_SCROLL_EDGE_PX = 84;

export const AUTO_SCROLL_MIN_SPEED_PX = 3;

export const AUTO_SCROLL_MAX_SPEED_PX = 22;
